// Moved from `src/hooks/query/useQueryJoinedOrganization.ts` (now a shim)
// with OT3 slice 2 (ARCFE-955). Token-seam severance; the console.error +
// null-swallow is frozen behaviour — preserved, not improved.
import { useQuery } from '@tanstack/react-query';

import { GET_JOINED_ORGANIZATION } from '../../contracts/keys';
import { getJoinedOrganization } from '../api/organization';
import { getWorkspaceDataConfig } from '../config';
import { useQueryUser } from './useQueryUser';

export { GET_JOINED_ORGANIZATION };

export function useQueryJoinedOrganizations() {
  const token = getWorkspaceDataConfig().useAuthToken();
  const { data: userData } = useQueryUser();

  return useQuery({
    queryKey: [GET_JOINED_ORGANIZATION],
    retry: 3,
    staleTime: 5 * 60 * 1000, // 5 minutes — org settings (e.g. sharing toggles) need timely propagation
    enabled: !!token && !!userData,
    queryFn: async () => {
      try {
        const { data } = await getJoinedOrganization();
        return data;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
  });
}
